<div class="container-fluid py-3 reportsPage">
  <div class="row g-3">

    <!-- ---------------------------------------------------------------- -->
    <!--                          ANCHOR HEADER                           -->
    <!-- ---------------------------------------------------------------- -->
    <div class="col-12">
      <div class="d-flex flex-wrap align-items-start justify-content-between gap-3">

        <div class="reportsPage__heading">
          <h2 class="reportsPage__title mb-1">Reportes</h2>
          <p class="reportsPage__subtitle mb-0">
            @if (!reportService.loading) {
              <span class="reportsPage__subtitleStrong">{{ openCount }} reportes sin cerrar</span>
            } @else {
              <span>Cargando reportes</span>
            }
          </p>
        </div>

        <div class="d-flex align-items-center gap-2">

          <button
            type="button"
            class="btn reportsPage__ghostButton d-flex align-items-center"
            [disabled]="reportService.loading"
            (click)="refresh()"
            aria-label="Actualizar la lista de reportes">
            <i class="material-icons reportsPage__buttonIcon" aria-hidden="true">refresh</i>
            <span class="d-none d-sm-inline ms-1">Actualizar</span>
          </button>

          <button
            type="button"
            class="btn reportsPage__primaryButton d-flex align-items-center"
            (click)="create()">
            <i class="material-icons reportsPage__buttonIcon" aria-hidden="true">add</i>
            <span class="ms-1">Nuevo reporte</span>
          </button>

        </div>

      </div>
    </div>

    <!-- ---------------------------------------------------------------- -->
    <!--                           ANCHOR TABS                            -->
    <!-- ---------------------------------------------------------------- -->
    <div class="col-12">
      <div
        class="reportsPage__tabs"
        role="tablist"
        aria-label="Estado de los reportes">

        @for (tab of tabs; track tab.key) {

          <button
            type="button"
            role="tab"
            class="reportsPage__tab reportsPage__tab{{ tab.variant }}"
            [class.reportsPage__tabActive]="activeTab === tab.key"
            [attr.aria-selected]="activeTab === tab.key"
            aria-controls="reportsPanel"
            (click)="selectTab(tab.key)">

            <i class="material-icons reportsPage__tabIcon" aria-hidden="true">{{ tab.icon }}</i>
            <span class="reportsPage__tabLabel text-truncate">{{ tab.title }}</span>

            @if (!reportService.loading) {
              <span class="reportsPage__tabCount">{{ count(tab.key) }}</span>
            }

          </button>

        }

      </div>
    </div>

    <!-- ---------------------------------------------------------------- -->
    <!--                          ANCHOR CONTENT                          -->
    <!-- ---------------------------------------------------------------- -->
    <div
      class="col-12"
      id="reportsPanel"
      role="tabpanel"
      [attr.aria-label]="activeTabDefinition.title">

      <app-report-list
        [reports]="activeReports"
        [emptyMessage]="activeTabDefinition.emptyMessage">
      </app-report-list>

    </div>

    <div class="visually-hidden" role="status" aria-live="polite">
      @if (reportService.loading) {
        Cargando reportes
      } @else {
        {{ activeTabDefinition.title }}: {{ count(activeTab) }} reportes
      }
    </div>

  </div>
</div>
